export default __webpack_public_path__ + "media/images/logo-1bbca7c38f612e47c5569a1c85eece67.svg";